import { Cube } from '../cube/core/cube';
import * as CubeTree from '../cubeTree/index';
import Utils from '../utils/util';
import FrontCubeData from '../frontCubeData/index';
import Update from '../update/index';

// 图纸更新, 暂时只更新cubeData字段
function updatePaper(params): void {
    let newStageCube: CubeNode = new Cube(params.shelfData);

    newStageCube.walk((cube: CubeNode): void => {
        let oldCube: CubeNode = CubeTree.findByCubeId(cube.id);

        if (oldCube) {
            oldCube.cubeData = Utils.deepCopy(cube.cubeData);
        }
    });
    FrontCubeData.updateAllCube();
    Update.updateAllCubes();
}

export {
    updatePaper
};
